import React from "react";
import { Route, Switch } from "react-router-dom";
import AppliedRoute from "./components/AppliedRoute";

import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import CreateUser from "./containers/CreateUser";
import AdminUpdateUserAttributes from "./containers/AdminUpdateUserAttributes";
import ChangePassword from "./containers/ChangePassword";
import noAction from "./containers/noAction";   // #4285 작업공지 팝업 - 현재 작업 시간의 경우 표시

export default function Routes({ appProps }) {
  return (
    <Switch>
      <AppliedRoute path="/" exact component={Home} appProps={appProps} />
      <AppliedRoute path="/login" exact component={Login} appProps={appProps} />
      <AppliedRoute path="/signup" exact component={Signup} appProps={appProps} />
      <AppliedRoute path="/adminCreateUser" exact component={CreateUser} appProps={appProps} />
      <AppliedRoute path="/adminUpdateUserAttributes" exact component={AdminUpdateUserAttributes} appProps={appProps} />
      <AppliedRoute path="/ChangePassword" exact component={ChangePassword} appProps={appProps} />
      <AppliedRoute path="/noAction" exact component={noAction} appProps={appProps} />
      { /* Finally, catch all unmatched routes */ }
      <Route component={NotFound} />
    </Switch>
  );
}
